import { createSlice } from "@reduxjs/toolkit";

interface CommonAction {
  payload: {
    method: string;
    url: string;
    body?: any;
    action?: any;
    callback?: any;
    errorCallback?: boolean;
    headers?: Record<string, string>;  
  };
  type: string;
}

const initialState = {};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    fetchCommonData: (state, action: CommonAction) => {},
  },
});
export const { fetchCommonData } = commonSlice.actions;
export default commonSlice.reducer;
